import type { AnyAction } from 'redux';
import type { RootState } from '../types';

export type BackendThunkAction = (dispatch: (...args: unknown[]) => unknown, getState: () => RootState) => unknown;
export type BackendDispatchAction = AnyAction | BackendThunkAction;
export type UnknownDispatch = (action: unknown) => unknown;

export const dispatchBackend = (dispatch: UnknownDispatch, action: BackendDispatchAction | unknown): unknown => dispatch(action);
